// extracted by mini-css-extract-plugin
var _1 = "aSBkswPz";
var _2 = "teSzgQ6N";
var _3 = "C8Dn1lrC";
export { _1 as "content", _2 as "heading", _3 as "page" }
